<div class="row">
  <div class="col-md-6">
    <div class>
      <form class="form-horizontal" #CrewAppraisal="ngForm">
        <mat-card appearance="outlined">
          <mat-card-header>
            <mat-card-title>Crew Appraisal</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="form-group row">
              <div class="col-md-12">
                <app-material-auto-complete
                  name="rank"
                  id="rank"
                  [formatter]="rankFormatter"
                  [(ngModel)]="rank"
                  [items]="ranks"
                  [placeholder]="'Position/Rank'"
                  [required]="true">
                </app-material-auto-complete>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-12">
                <mat-select
                  id="selectedVessel"
                  name="selectedVessel"
                  class="form-control"
                  [disabled]="!rank"
                  [(ngModel)]="selectedVessel"
                  [placeholder]="'Vessel'"
                  required>
                  @for (vessel of vessels; track $index) {
                    <mat-option
                      [value]="vessel">
                      {{vessel.name!.name}}
                    </mat-option>
                  }
                </mat-select>
              </div>
              <div class="form-group row">
                <div class="col-md-12">
                  <app-material-organisation-selector
                    name="selectedManagement"
                    id="selectedManagement"
                    [(ngModel)]="selectedTechnicalManagement"
                    [organisations]="technicalManagements"
                    [organisationLanguage]="'en'"
                    [disabled]="!selectedVessel"
                    [placeholder]="'Technical Management'"
                    [required]="true">
                  </app-material-organisation-selector>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-12">
                <app-material-pg-input
                  type="date"
                  label="Date"
                  [disabled]="!selectedTechnicalManagement"
                  [(ngModel)]="appraisalDate"
                  id="appraisalDate"
                  name="appraisalDate"
                  [required]="true">
                </app-material-pg-input>
              </div>
              <div class="form-group row">
                <div class="col-md-12">
                  <app-material-auto-complete
                    name="master"
                    id="master"
                    [formatter]="crewFormatter"
                    [(ngModel)]="master"
                    [disabled]="!appraisalDate"
                    [items]="crews"
                    [placeholder]="'Master'"
                    [required]="true">
                  </app-material-auto-complete>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-12">
                  <app-material-auto-complete
                    name="assessor"
                    id="assessor"
                    [formatter]="crewFormatter"
                    [(ngModel)]="assessor"
                    [disabled]="!master"
                    [items]="crews"
                    [placeholder]="'Assessor'"
                    [required]="true">
                  </app-material-auto-complete>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-12">
                  <app-material-chunk-file-uploader
                    id="reportFile"
                    [disabled]="!assessor"
                    [accept]="'.pdf'"
                    name="reportFile"
                    [(ngModel)]="doc"
                    (ngModelChange)="documentFileAdded($event)"
                    [required]="!doc">
                  </app-material-chunk-file-uploader>
                </div>
              </div>
            </div>
            @if (hasRole('vessels-crew-change-editor')) {
              <div class="btn-group pull-right mt-3"
                >
                <button
                  mat-stroked-button
                  type="button"
                  id="add"
                  class="col-md-4"
                  [disabled]="!CrewAppraisal.form.valid"
                  (click)="add()">
                  Add
                </button>
              </div>
            }
          </mat-card-content>
        </mat-card>
      </form>
    </div>
  </div>
  <div class="col-md-6">
    <app-crew-assignments [crew]="selectedCrew"> </app-crew-assignments>
    @if (document) {
      <app-material-pdf-viewer [fileId]="document?.id"/>
    }
  </div>

</div>
